import { useEffect, useState, useRef } from 'react';
import { NAVIGATION_HEIGHT, NAVIGATION_HEIGHT_MOBILE, GLOBAL_NAV_HEIGHT } from 'consts';
import { SCREEN_SIZES } from 'style';

const useNavHeight = () => {
  const [navHeight, setNavHeight] = useState(NAVIGATION_HEIGHT);
  const lastScrollPos = useRef(0);

  useEffect(() => {
    const changeNavHeight = () => {
      const currentScrollPos = window.pageYOffset;

      const productNavbarHeight =
        window.innerWidth >= SCREEN_SIZES.desktop
          ? NAVIGATION_HEIGHT
          : NAVIGATION_HEIGHT_MOBILE;

      if (
        window.innerWidth < SCREEN_SIZES.desktop &&
        currentScrollPos < lastScrollPos.current &&
        currentScrollPos !== 0
      ) {
        setNavHeight(productNavbarHeight + GLOBAL_NAV_HEIGHT);
      } else {
        setNavHeight(productNavbarHeight);
      }

      lastScrollPos.current = currentScrollPos;
    };
    changeNavHeight();
    window.addEventListener('scroll', changeNavHeight);
    window.addEventListener('resize', changeNavHeight);
    return () => {
      window.removeEventListener('resize', changeNavHeight);
      window.removeEventListener('scroll', changeNavHeight);
    };
  }, []);
  return navHeight;
};

export default useNavHeight;
